'use strict';
import $ from 'jquery';
import Cookie from './Cookie';

/**
 * Init
 */

var OVERLAYS, ALLOWED, CONFIG;
ALLOWED = false;
OVERLAYS = [];
CONFIG = {
  cookieNamePrefix: 'Widget',
  facebook: {
    link: 'Inhalt von Facebook zulassen',
    icon: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m9.157 23-.032-10h-4V9h4V6.5c0-3.711 2.298-5.5 5.61-5.5 1.585 0 2.948.118 3.345.171V5.05h-2.296c-1.8 0-2.15.856-2.15 2.112V9h5.241l-2 4h-3.24v10H9.157z" fill="#F5F5F5" fill-rule="nonzero" /></svg>',
  },
  twitter: {
    link: 'Inhalt von Twitter zulassen',
    icon: '<svg width="24" height="24" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" fill="#F5F5F5" fill-rule="nonzero" /></svg>',
  },
  linkedIn: {
    link: 'Inhalt von LinkedIn zulassen',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" fill="#F5F5F5"/></svg>',
  },
  youtube: {
    header: 'YouTube-Datenschutzhinweis',
    link: '<span>Dieses Video kommt von YouTube. Mit dem Abspielen kann YouTube das Surf-Verhalten mitverfolgen.</span>',
    icon: '<svg width="24" height="16.8" viewBox="0 0 24 16.8" xmlns="http://www.w3.org/2000/svg"><path class="b" d="M23.8,3.6s-.2-1.7-1-2.4c-.9-1-1.9-1-2.4-1-3.4-.2-8.4-.2-8.4-.2h0S7,0,3.6,.2c-.5,.1-1.5,.1-2.4,1C.5,1.9,.2,3.6,.2,3.6c0,0-.2,1.9-.2,3.9v1.8c0,1.9,.2,3.9,.2,3.9,0,0,.2,1.7,1,2.4,.9,1,2.1,.9,2.6,1,1.9,.2,8.2,.2,8.2,.2,0,0,5,0,8.4-.3,.5-.1,1.5-.1,2.4-1,.7-.7,1-2.4,1-2.4,0,0,.2-1.9,.2-3.9v-1.8c0-1.9-.2-3.8-.2-3.8Zm-14.3,7.9V4.8l6.5,3.4-6.5,3.3Z" fill="#F5F5F5"/></svg>',
  },
  googleMap: {
    link: 'Inhalt von Google Maps zulassen',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g class="nc-icon-wrapper" fill="#ffffff"><path data-color="color-2" d="M16,0c-1.671,0-3.363,0.545-4.76,1.55C14.92,2.796,18,6.131,18,11 c0,2.685-1.638,5.724-3.466,8.288c0.362,0.389,0.638,0.673,0.756,0.792c0.188,0.189,0.443,0.295,0.71,0.295s0.522-0.106,0.71-0.295 C17.456,19.327,24,12.6,24,8C24,2.992,19.933,0,16,0z"></path> <path fill="#ffffff" d="M8,3c-3.933,0-8,2.992-8,8c0,4.6,6.544,11.327,7.29,12.08c0.188,0.189,0.443,0.295,0.71,0.295 s0.522-0.106,0.71-0.295C9.456,22.327,16,15.6,16,11C16,5.992,11.933,3,8,3z M8,13c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2 s2,0.895,2,2C10,12.105,9.105,13,8,13z"></path></g></svg>',
  },
};

function removeOverlays() {
  $.each(OVERLAYS, function () {
    removeOverlay(this);
  });
  OVERLAYS = [];
}

function enableWidget(overlay) {
  removeOverlay(overlay);
}

function removeOverlay(overlay) {
  overlay.$overlay.remove();
  overlay.$container.removeClass('has-social-media-overlay');
  let iframe = overlay.$iframe;
  iframe.attr('src', iframe.data('src'));
  overlay.$container.closest('.MediaItem').find('.MediaItem__InfoBar').hide();
}

(function () {
  window.SocialMediaWidgets = {
    allow: function () {
      ALLOWED = true;
      removeOverlays();
    },
    allowIframe: function (e) {
      var iframe, src;
      iframe = document.getElementById(e);
      src = iframe.getAttribute('data-src');
      iframe.setAttribute('src', src);
    },
  };
  $(document).ready(function () {
    if (!ALLOWED) {
      $('.social-media-widget').each(function () {
        var $container, $script, $iframe, overlay, type;
        try {
          $container = $(this);
          $script = $(this).find('[data-social-media-script]');
          $iframe = $(this).find('iframe');
          type = 'youtube';
          $container.addClass('has-social-media-overlay');
          $container.css(
            'background-image',
            'url(' + $container.data('poster') + ')'
          );
          // $container.attr('tabindex', 0);
          overlay = {
            type: type,
            $container: $container,
            $script: $script,
            $iframe: $iframe,
            $overlay: $('<div>')
              .addClass('social-media-overlay')
              .append(
                $('<h4>').addClass('').html(CONFIG[type].header),
                $('<button>')
                  .addClass('social-media-overlay-button btn')
                  .html(CONFIG[type].link)
                  .append($('<i>').addClass('icon-youtube'))
                  .on('click', function () {
                    let cookiename = CONFIG.cookieNamePrefix + '-' + type;
                    Cookie.set(cookiename, 'true', 30);
                    enableWidget(overlay);
                  })
              ),
          };
          OVERLAYS.push(overlay);
          $container.append(overlay.$overlay);
        } catch (e) {
          console.error(e);
        }
      });
    }
  });

  let cookiename = CONFIG.cookieNamePrefix + '-youtube';
  let ytEnabled = Cookie.get(cookiename);
  if (ytEnabled) {
    window.SocialMediaWidgets.allow();
    $('.social-media-widget').each(function () {
      var $iframe;
      $iframe = $(this).find('iframe');
      $iframe.attr('src', $iframe.data('src'));

      $(this).closest('.MediaItem').find('.MediaItem__InfoBar').hide();
    });
  }
})();
